export const ADD_TO_CART = "ADD_TO_CART";

export const UPDATE_CART = "UPDATE_CART";

export const ELIMINATE_ITEM = "ELIMINATE_ITEM";

export const REQUEST_PRODUCT_DATABASE_PENDING = "REQUEST_PRODUCT_DATABASE_PENDING";

export const REQUEST_PRODUCT_DATABASE_RESOLVED = "REQUEST_PRODUCT_DATABASE_RESOLVED";

export const REQUEST_PRODUCT_DATABASE_REJECTED = "REQUEST_PRODUCT_DATABASE_REJECTED";
